import { useCallback } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import constate from '@/lib/constate'

import { useAppBuilderContext } from '../AppBuilderContext'

export type PageLocationState = {
  tablePageId?: string
  rowIndex?: number
}

export type PageNavigationArgs = {
  slug?: string
  rowId?: string
  state?: PageLocationState
  replace?: boolean
  redirect?: string
}

interface AppRoutingProviderProps {
  rootPath: string
}

const [AppRoutingProvider, useAppRoutingContext] = constate(
  'AppRoutingContext',
  ({ rootPath }: AppRoutingProviderProps) => {
    const { setPageAction } = useAppBuilderContext()

    // Access Route
    const navigate = useNavigate()
    const params = useParams()
    const currentSlug = params['slug'] || ''
    const currentRowId = params['rowId'] || ''

    const loc = useLocation()
    const locationState = loc.state as PageLocationState

    // navigate page
    const goToPage = useCallback(
      ({ slug, rowId, state, replace = false, redirect }: PageNavigationArgs) => {
        const currPath = location.pathname.split(rootPath)[0]
        let nextPath = currPath
        if (slug) {
          nextPath += rootPath === '/' ? `/${slug}` : `${rootPath}/${slug}`
        }
        if (rowId) {
          nextPath += `/${rowId}`
        }
        // if (redirect) {
        //   nextPath += `?next=${redirect}`
        // }
        navigate(nextPath, { replace, state })
      },
      [navigate, rootPath]
    )

    const handleGoBack = useCallback(() => {
      // check history stack
      const history = window.history
      const currentIndex = history.state.index
      const previousIndex = currentIndex - 1

      // if not previous history, go to home
      if (previousIndex < 0) {
        navigate('/')
      } else {
        navigate(-1)
      }

      setPageAction(undefined)
      //
    }, [navigate, setPageAction])

    return {
      goToPage,
      handleGoBack,
      currentSlug,
      currentRowId,
      locationState,
    }
  }
)

export { AppRoutingProvider, useAppRoutingContext }
